import { render } from "./ANPCBanner.vue?vue&type=template&id=513f1b22&scoped=true"
import script from "./ANPCBanner.vue?vue&type=script&lang=js"
export * from "./ANPCBanner.vue?vue&type=script&lang=js"

import "./ANPCBanner.vue?vue&type=style&index=0&id=513f1b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513f1b22"]])

export default __exports__